<template>
  <page-outline 
    :title="listTitle"
    :show-refresh="true"
    :refresh-disabled="activateSpinner"
    @refresh="refreshCertificates">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <h1 class="sr-only">{{ listTitle }}</h1>
        <section aria-labelledby="certificate-list">
          <h2 id="certificate-list" class="sr-only">{{ $t('common.security.certificates_list') }}</h2>
          <b-row class="justify-content-center mb-5">
            <security-list typeList="certificate" :key="refreshKey" :spinnerActivated="activateSpinner"></security-list>
          </b-row>
        </section>
      </div>
    </template>
  </page-outline>
</template>

<script>
import SecurityList from '@/pages/security/SecurityList.vue'
import PageOutline from '@/components/common/PageOutline.vue'

export default {
  name: 'CertificatePage',
  components: {
    'page-outline': PageOutline,
    'security-list': SecurityList
  },
  props: {
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    canSeeCertificates () {
      return this.$engine.firstOn().rights.rightIs('certificate_consult', true)
    }
  },
  data () {
    return {
      activateSpinner: false,
      listTitle: '',
      refreshKey: false
    }
  },
  created () {
    this.listTitle = this.$i18n.t('common.security.certificates_consult_list')
    // Set page title for accessibility
    document.title = this.$i18n.t('common.security.certificates_consult_list') + ' - VOP'
    if (this.id !== '-1') {
      this.tabName = parseInt(this.id)
    }
  },
  methods: {
    refreshCertificates () {
      this.activateSpinner = true
      this.refreshKey = !this.refreshKey
      // Reset spinner after a short delay to allow the component to re-render
      this.$nextTick(() => {
        setTimeout(() => {
          this.activateSpinner = false
        }, 1000)
      })
    }
  }
}
</script>
